import React from 'react';

import Button from '../../library/button/button';
import { AngleLeftLightIcon } from '../../shared/icons/icons';

import './back-button.scss';

interface BackButtonProps {
  className?: string;
  href?: string;
  onClick?: () => void;
  text?: string;
}

function BackButton(props: BackButtonProps) {
  const { className, href, onClick, text } = props;

  return (
    <Button
      className={`${className || ''} back-button`}
      href={href}
      onClick={() => {
        if (onClick) onClick();
      }}
      size="regular"
      styleName="back-button"
      type="button"
    >
      <AngleLeftLightIcon
        aria-hidden="true"
        className="back-button__back-icon"
        styleName="back-icon"
      />
      {text}
    </Button>
  );
}

export default BackButton;
